/* Bikeparts "Gallery" product card: colour swatches, quick add by size, mobile picker */
(function () {
  if (window.__bpCard) return; window.__bpCard = true;

  function data(card, sel) { var el = card.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function pos(card, k) { var v = card.getAttribute(k); return v ? parseInt(v, 10) - 1 : -1; }
  function curColour(card) { var on = card.querySelector('.bp-card__sw.is-on[data-bp-colour]'); return on ? on.getAttribute('data-bp-colour') : null; }

  function findVariant(card, size, colour) {
    var vs = data(card, '[data-bp-variants]') || [];
    var sp = pos(card, 'data-size-pos'), cp = pos(card, 'data-col-pos');
    var best = null;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (sp >= 0 && size != null && v.o[sp] !== size) continue;
      if (cp >= 0 && colour != null && v.o[cp] !== colour) continue;
      if (v.a) return v;
      if (!best) best = v;
    }
    // combined-listing sizes: the product's one variant is called "Default Title", not the size name
    if (!best && vs.length === 1) return vs[0];
    return best;
  }

  // add straight to the basket (same way as the product page), then refresh + open the basket drawer
  function add(card, variant) {
    if (!variant || !variant.a) { fail(card); return false; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    card.classList.add('is-adding');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(variant.id, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        card.classList.remove('is-adding');
        if (!res.ok) { fail(card, res.j.description || res.j.message); return; }
        card.classList.add('is-added'); setTimeout(function () { card.classList.remove('is-added'); }, 2500);
        if (document.querySelector('cart-drawer')) { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); }
        else { location.href = root + 'cart'; }
      })
      .catch(function () { card.classList.remove('is-adding'); var f = card.querySelector('form.bp-card__form'); if (f) { f.querySelector('[data-bp-id]').value = variant.id; f.submit(); } });
    return true;
  }

  // if an add ever fails, say so on the card and take them to the product page rather than doing nothing
  function fail(card, msg) {
    card.classList.remove('is-adding');
    var a = card.querySelector('a.bp-card__media, a.bp-card__title');
    var lab = card.querySelector('.bp-card__strip-label');
    if (lab) lab.textContent = msg || 'Choose your size on the product page';
    if (a) setTimeout(function () { location.href = a.href; }, 900);
  }

  // sizes that are separate products (Shopify combined listings): add that product's variant instead
  function sizeList(card) { return data(card, '[data-bp-sizes]'); }
  function sizeEntry(card, size) { var l = sizeList(card) || []; for (var i = 0; i < l.length; i++) if (l[i].n === size) return l[i]; return null; }
  function addSibling(card, url, vid, size) {
    if (vid) return Promise.resolve(add(card, { id: vid, a: true }));
    card.classList.add('is-adding');
    return fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      card.classList.remove('is-adding');
      if (!p || !p.variants) { location.href = url; return false; }
      var v = p.variants.filter(function (x) { return x.available && (x.options || []).indexOf(size) >= 0; })[0] || p.variants.filter(function (x) { return x.available; })[0];
      if (!v) { location.href = url; return false; }
      return add(card, { id: v.id, a: true });
    }).catch(function () { card.classList.remove('is-adding'); location.href = url; return false; });
  }

  function swapImage(card, src) {
    var img = card.querySelector('[data-bp-main], .bp-card__img--main'); if (!img || !src) return;
    if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origset = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset'); img.src = src;
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.bp-card__sw[data-img]'); if (!sw) return;
    swapImage(sw.closest('[data-bp-card]'), sw.getAttribute('data-img'));
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bp-card__sw[data-bp-colour], .bp-card__size, [data-bp-add], [data-bp-plus]');
    if (!t) return;
    var card = t.closest('[data-bp-card]'); if (!card) return;
    e.preventDefault(); e.stopPropagation();
    if (t.matches('.bp-card__sw')) {
      card.querySelectorAll('.bp-card__sw').forEach(function (s) { s.classList.toggle('is-on', s === t); });
      if (t.getAttribute('data-img')) swapImage(card, t.getAttribute('data-img'));
      return;
    }
    if (t.matches('.bp-card__size')) {
      if (t.disabled) return;
      if (card.classList.contains('is-adding')) return;
      if (t.getAttribute('data-bp-url')) { addSibling(card, t.getAttribute('data-bp-url'), t.getAttribute('data-bp-vid'), t.getAttribute('data-bp-size')); return; }
      add(card, findVariant(card, t.getAttribute('data-bp-size'), curColour(card))); return;
    }
    if (t.matches('[data-bp-add]')) { add(card, findVariant(card, null, curColour(card))); return; }
    if (t.matches('[data-bp-plus]')) { openSheet(card); }
  }, true);

  // sizes are stored in whatever order they were created (e.g. L, XL, M, S) - show them smallest to largest
  var LETTER = ['XXXS','XXS','XS','S','S/M','M','M/L','L','L/XL','XL','XXL','2XL','XXXL','3XL','4XL','5XL'];
  function rank(v) {
    var t = String(v).toUpperCase().replace(/^EU\s+/, '').split(' / ')[0].trim();
    var i = LETTER.indexOf(t); if (i < 0) i = LETTER.indexOf(t.replace(/\s+/g, ''));
    if (i >= 0) return [0, i];
    var n = parseFloat(t.replace(',', '.')); if (!isNaN(n)) return [1, n];
    return [2, 0];
  }
  function bySize(a, b) { var x = rank(a), y = rank(b); return x[0] - y[0] || x[1] - y[1]; }
  function sortStrip(c) {
    var box = c.querySelector('.bp-card__sizes'); if (!box || box.dataset.sorted) return; box.dataset.sorted = '1';
    var bs = Array.prototype.slice.call(box.querySelectorAll('.bp-card__size'));
    var keyed = bs.map(function (b, i) { return { b: b, i: i, k: rank(b.getAttribute('data-bp-size')) }; });
    if (keyed.some(function (o) { return o.k[0] === 2; })) return;
    keyed.sort(function (x, y) { return x.k[0] - y.k[0] || x.k[1] - y.k[1] || x.i - y.i; }).forEach(function (o) { box.appendChild(o.b); });
  }

  // mark main images that have a second photo so hover can cross-fade
  function markAlt(root) { (root || document).querySelectorAll('[data-bp-card]').forEach(function (c) { sortStrip(c); if (c.querySelector('.bp-card__img--alt')) { var m = c.querySelector('.bp-card__img--main'); if (m) m.classList.add('has-alt'); } }); }
  document.addEventListener('DOMContentLoaded', function () { markAlt(); });
  new MutationObserver(function () { markAlt(); }).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- mobile picker ----------
  var sheet = null;
  function el(tag, cls, html) { var x = document.createElement(tag); if (cls) x.className = cls; if (html != null) x.innerHTML = html; return x; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function openSheet(card) {
    var info = data(card, '[data-bp-info]') || {}; var vs = data(card, '[data-bp-variants]') || [];
    var sp = pos(card, 'data-size-pos'), cp = pos(card, 'data-col-pos');
    if (sp < 0 && cp < 0) { add(card, findVariant(card, null, null)); return; }
    if (!sheet) {
      sheet = el('div', 'bp-sheet'); sheet.innerHTML = '<div class="bp-sheet__bg"></div><div class="bp-sheet__panel" aria-label="Choose options"></div>';
      document.body.appendChild(sheet);
      // tap anywhere outside the panel to close (touchend as well as click, as iPhones don't always send a click on a plain backdrop)
      var outside = function (e) { var pnl = sheet.querySelector('.bp-sheet__panel'); if (sheet.classList.contains('is-shown') && !pnl.contains(e.target)) { e.preventDefault(); closeSheet(); } };
      sheet.addEventListener('click', outside);
      sheet.addEventListener('touchend', outside);
      // swipe down on the panel to close it
      var sp0 = sheet.querySelector('.bp-sheet__panel'), y0 = null, dy = 0;
      sp0.addEventListener('touchstart', function (e) { if (sp0.scrollTop > 0) { y0 = null; return; } y0 = e.touches[0].clientY; dy = 0; sp0.style.transition = 'none'; }, { passive: true });
      sp0.addEventListener('touchmove', function (e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); sp0.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
      sp0.addEventListener('touchend', function () { if (y0 == null) return; sp0.style.transition = ''; sp0.style.transform = ''; if (dy > 80) closeSheet(); y0 = null; });
    }
    var panel = sheet.querySelector('.bp-sheet__panel'); panel.innerHTML = '';
    panel.appendChild(el('span', 'bp-sheet__grab'));
    var x = el('button', 'bp-sheet__close', '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>');
    x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.addEventListener('click', closeSheet); panel.appendChild(x);
    panel.appendChild(el('div', 'bp-sheet__head', (info.img ? '<img class="bp-sheet__img" src="' + esc(info.img) + '" alt="">' : '') +
      '<div style="display:flex;flex-direction:column;gap:3px;min-width:0"><span class="bp-sheet__v">' + esc(info.v || '') + '</span><span class="bp-sheet__t">' + esc(info.t || '') + '</span><span class="bp-sheet__p">' + esc(info.p || '') + '</span></div>'));
    var state = { c: curColour(card), s: null };
    function uniq(i) { var out = []; vs.forEach(function (v) { if (out.indexOf(v.o[i]) < 0) out.push(v.o[i]); }); return out; }
    var go = el('button', 'bp-sheet__go'); go.type = 'button';
    function refresh() {
      panel.querySelectorAll('[data-s]').forEach(function (b) {
        var se = sizeEntry(card, b.getAttribute('data-s'));
        var ok = (se && se.u) ? se.a : (se && vs.length === 1) ? (se.a && vs[0].a) : vs.some(function (v) { return v.a && v.o[sp] === b.getAttribute('data-s') && (cp < 0 || state.c == null || v.o[cp] === state.c); });
        b.disabled = !ok; b.classList.toggle('is-on', b.getAttribute('data-s') === state.s && ok);
        if (!ok && state.s === b.getAttribute('data-s')) state.s = null;
      });
      panel.querySelectorAll('[data-c]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-c') === state.c); });
      var need = sp >= 0 && !state.s;
      go.disabled = need; go.textContent = need ? 'Pick a size' : 'Add to basket';
    }
    if (cp >= 0) {
      var cw = el('div', null); cw.style.cssText = 'display:flex;flex-direction:column;gap:8px';
      cw.appendChild(el('span', 'bp-sheet__lab', 'Colour'));
      var co = el('div', 'bp-sheet__opts');
      uniq(cp).forEach(function (c) {
        var src = card.querySelector('.bp-card__sw[data-bp-colour="' + (window.CSS && CSS.escape ? CSS.escape(c) : c) + '"]');
        var bg = src ? (src.style.backgroundImage && src.style.backgroundImage !== 'none' ? 'background-image:' + src.style.backgroundImage + ';background-size:cover' : 'background:' + src.style.backgroundColor) : 'background:#d5d9e0';
        var b = el('button', 'bp-sheet__opt', '<span class="bp-sheet__dot" style="' + bg + '"></span>' + esc(c)); b.type = 'button'; b.setAttribute('data-c', c);
        b.addEventListener('click', function () { state.c = c; if (src) { card.querySelectorAll('.bp-card__sw').forEach(function (s) { s.classList.toggle('is-on', s === src); }); } refresh(); });
        co.appendChild(b);
      });
      cw.appendChild(co); panel.appendChild(cw);
    }
    if (sp >= 0) {
      var sw = el('div', null); sw.style.cssText = 'display:flex;flex-direction:column;gap:8px';
      sw.appendChild(el('span', 'bp-sheet__lab', 'Add to basket – select size'));
      var so = el('div', 'bp-sheet__opts');
      var sl = sizeList(card);
      var sizes = sl && sl.length ? sl.map(function (o) { return o.n; }) : uniq(sp); if (!sizes.some(function (v) { return rank(v)[0] === 2; })) sizes.sort(bySize);
      sizes.forEach(function (s) {
        var lab = s.replace(/^EU\s+/, '').split(' / ')[0];
        var b = el('button', 'bp-sheet__opt', esc(lab)); b.type = 'button'; b.setAttribute('data-s', s);
        b.addEventListener('click', function () { if (!b.disabled) { state.s = s; refresh(); } });
        so.appendChild(b);
      });
      sw.appendChild(so); panel.appendChild(sw);
    }
    go.addEventListener('click', function () {
      var se = state.s ? sizeEntry(card, state.s) : null;
      if (se && se.u) { go.disabled = true; addSibling(card, se.u, se.id, se.n).then(function (ok) { if (ok) closeSheet(); else refresh(); }); return; }
      var v = findVariant(card, state.s, state.c); if (add(card, v)) closeSheet();
    });
    panel.appendChild(go);
    refresh();
    sheet.classList.add('is-open'); document.documentElement.classList.add('bp-sheet-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-shown'); }); });
  }
  function closeSheet() { if (!sheet) return; sheet.classList.remove('is-shown'); document.documentElement.classList.remove('bp-sheet-lock'); setTimeout(function () { sheet.classList.remove('is-open'); }, 250); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
})();
